import { rankDemoGaps, groupsFromSpendRow, MIN_GAP } from "./demoGaps";

export const fmt = (n) => (Math.round(n * 100) / 100).toFixed(2);

export const DEMO_LABELS = {
  african_male:    'African Male',
  african_female:  'African Female',
  coloured_male:   'Coloured Male',
  coloured_female: 'Coloured Female',
  indian_male:     'Indian Male',
  indian_female:   'Indian Female',
};

const DEMOS = Object.keys(DEMO_LABELS);

const FEMALE_DEMOS = ['african_female', 'coloured_female', 'indian_female'];

const FEMALE_IND_IDS = new Set([
  'black_female_board_participation',
  'female_executive_directors',
  'female_other_executive',
  'senior_female',
  'middle_female',
  'junior_female',
]);

const getMcRecText = (ind, actual, pts, spendRow) => {
  const total = spendRow.total || 0;
  if (total === 0) return null;

  const isFemale = FEMALE_IND_IDS.has(ind.id);
  const relevantDemos = isFemale ? FEMALE_DEMOS : DEMOS;

  const currentBlack = relevantDemos.reduce((s, d) => s + (spendRow[d] || 0), 0);

  const newPct = ((currentBlack + 1) / (total + 1)) * 100;
  const pointGain = Math.min(newPct / ind.target, 1) * ind.points - pts;

  let biggest = null;
  relevantDemos.forEach((d) => {
    const targetCount = spendRow.target?.[d] ?? 0;
    const actualCount = spendRow[d] ?? 0;
    const gap = targetCount - actualCount;
    if (!biggest || gap > biggest.gap) biggest = { label: DEMO_LABELS[d], gap };
  });

  if (!biggest) return null;

  const gainStr = pointGain > 0.001
    ? ` will add ${fmt(pointGain)} pts`
    : ' would not change points (already capped)';
  const gapDetail = biggest.gap > 0 ? ` (${biggest.gap} still needed to reach target)` : '';
  return `Having 1 ${biggest.label}${gainStr}${gapDetail}.`;
};

export const getBiggestDemoGap = (spendRow) => {
  const top = rankDemoGaps(groupsFromSpendRow(spendRow, DEMOS))[0];
  return top ? { label: DEMO_LABELS[top.key], gap: top.gap } : null;
};

export const getRecText = (ind, actual, totalGap, spendRow) => {
  if (spendRow?.total != null && !spendRow?.map_vals) {
    const pts = ind.points - totalGap;
    const mcRec = getMcRecText(ind, actual, pts, spendRow);
    if (mcRec) return mcRec;
  }

  const notScoring = !actual || actual === 0;
  const actStr = notScoring ? '0%' : `${fmt(actual)}%`;
  const gapStr = `${fmt(totalGap)} point${totalGap === 1 ? '' : 's'}`;
  const top = getBiggestDemoGap(spendRow);
  if (top && top.gap > MIN_GAP) {
    const focusStr = `${top.label} (up to ${fmt(top.gap)} pts)`;
    if (notScoring)
      return `Not currently scoring — ${gapStr} available. Biggest opportunity: ${focusStr}.`;
    return `${gapStr} still available from ${actStr}. Biggest opportunity: ${focusStr}.`;
  }
  if (notScoring)
    return `Not currently scoring. Achieving the ${ind.target}% target would add ${gapStr}.`;
  return `Currently at ${actStr}. Achieving the ${ind.target}% target would add ${gapStr}.`;
};
